import { Callout } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  reason?: string;
};

export const InvalidProofBanner = ({ reason }: Props) => {
  const { t } = useTranslation('global');

  return (
    <Callout
      variant="warning"
      className="mb-16"
      title={t('misc.receiptDeclaredAsInvalid')}
    >
      {reason && <div>« {reason} »</div>}
    </Callout>
  );
};
